import { useCallback } from "react";
import { SignalMapping, Modules } from "../models/electronicsConfiguration.ts";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useElectronicModules = () => {
  const { handle} = useMessageHandler();

  const electronicModules = useCallback(async (
    payload: SignalMapping, 
  ): Promise<Modules | null> => {
    return await handle(async () => {
      const response = await apiJson.post("/electronics/modules", payload);
      return response.data as Modules;
    }).catch(() => null);
  }, [handle]);

  return { electronicModules };
};
